import request from '@/utils/request'

/**
 * 获取视频流地址
 * 文档参考: https://open.ys7.com/help/1414
 * @param {object} params
 * @param {string} params.device_serial - 设备序列号
 * @param {number} [params.channel_no=1] - 通道号
 * @param {string} [params.protocol=hls] - 协议类型 (hls, flv, rtmp)
 */
export function getVideoStream (params) {
  return request({
    url: '/wms/ezviz/video_stream/',
    method: 'get',
    params
  })
}
